import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
export class DeferSkeletons extends SkeletonRegistryCategory {
    label = 'Defer';
    constructor(parent) {
        super(parent);
    }
}
